// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"b4bb747c","159":"ca03b315","197":"31d97001","213":"6efbd168","258":"f91d31e5","324":"32e2531e","453":"84065ba8","499":"2aa2596d","531":"0dfe23a4","585":"dc5b71e0","645":"3f1fb1fc","696":"a54ff276","846":"d5284747","899":"0dbacf2c","979":"3c9a1958"}[chunkId] + ".chunk.js";
};